import { useEffect } from 'react'
import { warmUpApi } from '../api/client'
import { DocumentMeta } from '../components/DocumentMeta'
import { Icon, type IconName } from '../components/Icon'
import { PlateSearch } from '../components/PlateSearch'
import { HOME_META } from '../domain/meta'

const FEATURES: { icon: IconName; title: string; body: string }[] = [
  {
    icon: 'shield',
    title: 'APK en bevindingen',
    body: 'Tot wanneer de APK geldig is, en wat er bij elke keuring is aangetroffen.',
  },
  {
    icon: 'gauge',
    title: 'Tellerstandcontrole',
    body: 'Het oordeel van de RDW over de geregistreerde kilometerstanden, met toelichting.',
  },
  {
    icon: 'warning',
    title: 'Terugroepacties',
    body: 'Openstaande en afgehandelde terugroepacties van de fabrikant, met het gevaar en het herstel.',
  },
  {
    icon: 'car',
    title: 'Techniek en milieu',
    body: 'Vermogen, gewichten, maten, verbruik, uitstoot en het energielabel.',
  },
]

export function HomePage() {
  // On load rather than on the first keystroke: the plate field is focused already, and the time
  // spent reading the page is cold start the visitor will not have to sit through afterwards.
  useEffect(warmUpApi, [])

  return (
    <>
      <DocumentMeta {...HOME_META} />

      <div className="hero">
        <div className="container hero__inner">
          <div className="hero__copy">
            <h1>Gratis kentekencheck</h1>
            {/*
              Not "alles wat de RDW openbaar maakt": the report is worth more to a visitor who is
              not being told, in the first sentence, that its contents are a public dataset they
              could go and read themselves.
            */}
            <p>
              Voer een Nederlands kenteken in en zie in één overzicht alle RDW-gegevens over de
              auto. Geen account, geen kosten.
            </p>
          </div>

          <div className="search-card">
            <p className="search-card__title">AUTOCHECKEN.COM</p>
            <PlateSearch autoFocus examples />
          </div>
        </div>
      </div>

      <main className="container" id="main">
        <div className="feature-grid">
          {FEATURES.map((feature) => (
            <div className="feature" key={feature.title}>
              <span className="feature__icon">
                <Icon name={feature.icon} size={26} />
              </span>
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.body}</p>
              </div>
            </div>
          ))}
        </div>

        <section className="home-closing">
          <h2>Voorkom een miskoop</h2>
          <p>Check de auto voordat je gaat kijken. Het kost je één kenteken.</p>
          <div className="home-closing__search">
            <PlateSearch />
          </div>
        </section>
      </main>
    </>
  )
}
